import { render } from "./gfigmodule.vue?vue&type=template&id=28890a30&scoped=true"
import script from "./gfigmodule.vue?vue&type=script&lang=js"
export * from "./gfigmodule.vue?vue&type=script&lang=js"

import "./gfigmodule.vue?vue&type=style&index=0&id=28890a30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28890a30"]])

export default __exports__